import React, { Component } from 'react';
import firebase from 'firebase';
import {Label, Table } from 'react-bootstrap';

type IProps = {
  room: string,
  user: Object,
}

type IState = {
  phrases: Object,
  vocabulary: Object,
}

class DetailUser extends Component {

  constructor(props: IProps) {
    super(props);

    this.state = {
      phrases: {},
      vocabulary: {},
    };
  }

  state: IState;

  componentDidMount() {
    const { room, user } = this.props;

    firebase.database().ref(`room/${room}/statistics/phrase`).orderByChild('user').equalTo(user.uid).on('value', (snapshot) => {
      this.setState({
        phrases: snapshot.val() || {},
      })
    });
    firebase.database().ref(`room/${room}/statistics/vocabulary`).orderByChild('user').equalTo(user.uid).on('value', (snapshot) => {
      this.setState({
        vocabulary: snapshot.val() || {},
      })
    });
  }
  
  props: IProps;

  render() {
    const { user } = this.props;
    const { phrases, vocabulary } = this.state;

    const rows = {};

    Object.keys(phrases).forEach((key) => {
      const phrase = phrases[key];

      const hour = parseInt(phrase.date / (1000 * 60 * 60));
      if (!rows[hour]) {
        rows[hour] = {};
        rows[hour]['phrase'] = {
          success: 0,
          error: 0,
        };
        rows[hour]['vocabulary'] = {
          success: 0,
          error: 0,
        };
      }
      if (phrase.valid) {
        rows[hour].phrase.success += 1;
      } else {
        rows[hour].phrase.error += 1;
      }
    });
    
    Object.keys(vocabulary).forEach((key) => {
      const word = vocabulary[key];
      
      const hour = parseInt(word.date / (1000 * 60 * 60));
      if (!rows[hour]) {
        rows[hour] = {};
        rows[hour]['phrase'] = {
          success: 0,
          error: 0,
        };
        rows[hour]['vocabulary'] = {
          success: 0,
          error: 0,
        };
      }
      if (word.valid) {
        rows[hour].vocabulary.success += 1;
      } else {
        rows[hour].vocabulary.error += 1;
      }
    });

    return (
      <div>
        <p>Signed Up: <strong>{new Date(user.created_at).toUTCString()}</strong></p>
        {/*const data = {"labels":["January","February","March","April","May","June","July"],"datasets":[{"label":"My First Dataset","data":[65,59,80,81,56,55,40],"fill":false,"borderColor":"rgb(75, 192, 192)","lineTension":0.1}]};
  
    const options = {
      scales: {
        xAxes: [{
          time: {
            unit: 'month'
          }
        }]
      },
      responsive: true,
    };<Bar data={data} options={options} />*/}
        {
          Object.keys(rows).length > 0 && (
            <Table striped bordered condensed hover>
              <thead>
                <tr>
                  <th><strong>Date</strong></th>
                  <th><strong>Phrases</strong></th>
                  <th><strong>Vocabulary</strong></th>
                </tr>
              </thead>
              <tbody>
                {
                  Object.keys(rows).map((key) => {
                    const row = rows[key];
                    const date = new Date(key * 1000 * 60 * 60);
    
                    return (
                      <tr>
                        <td><strong>{date.getDate()}. {date.getMonth() + 1}. {date.getFullYear()} {date.getHours()}:00</strong></td>
                        <td>
                          {
                            (row.phrase.success > 0 || row.phrase.error > 0) && (
                              <div>
                                <Label bsStyle="success">{row.phrase.success}</Label>&nbsp;
                                <Label bsStyle="danger">{row.phrase.error}</Label>
                              </div>
                            )
                          }
                        </td>
                        <td>
                          {
                            (row.vocabulary.success > 0 || row.vocabulary.error > 0) && (
                              <div>
                                <Label bsStyle="success">{row.vocabulary.success}</Label>&nbsp;
                                <Label bsStyle="danger">{row.vocabulary.error}</Label>
                              </div>
                            )
                          }
                        </td>
                      </tr>
                    );
                  })
                }            
              </tbody>
            </Table>
          )
        }
      </div>
    );
  }
}

export default DetailUser;


// WEBPACK FOOTER //
// ./src/pages/Users/DetailUser.js